import { c as _c } from "react-compiler-runtime";
import { getAssetKeyFromAsset } from '../utils/multipleAssets';
import usePrevious from './usePrevious';

/**
 * NOTE - this will fire even if changes are from the current user.
 * We refetch as otherwise we can't guarantee we haven't missed
 * changes from other users
 */
export default function useIsCommentsDataStale(t0) {
  "use memo";

  const $ = _c(3);
  const {
    objectType,
    objectId,
    assetsLastUpdated
  } = t0;
  const prevAssetsLastUpdated = usePrevious(assetsLastUpdated);
  if (!objectId || !objectType) {
    return false;
  }
  let t1;
  if ($[0] !== objectId || $[1] !== objectType) {
    t1 = getAssetKeyFromAsset({
      objectId,
      objectType
    });
    $[0] = objectId;
    $[1] = objectType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const assetKey = t1;
  return prevAssetsLastUpdated && assetKey in prevAssetsLastUpdated && assetsLastUpdated[assetKey] !== prevAssetsLastUpdated[assetKey];
}